import { createAction } from "@reduxjs/toolkit";

export const activateSpinner = createAction<boolean>('spinner/activate');